import {TAppThunk} from 'core/redux/types';
import {actionSetBreadCrumbsList} from 'modules/breadcrumbs/slice';
import {selectCategoryBySectionId} from 'modules/categories/selectors';
import {CategoryService} from 'modules/categories/services/CategoryService';
import {Category} from 'new-models';
import {CATALOG_ROUTE, PAGES} from 'routing/constants';
import {IShopPage} from 'routing/types';

export const getBreadCrumbsList =
    (categoryIdList: Category['id'][], options?: {isLastActive: boolean}): TAppThunk<void> =>
    async (dispatch, getState) => {
        const categoryPageList = categoryIdList.reduce(
            (pageList: IShopPage[], categoryId) => {
                const category = selectCategoryBySectionId(categoryId)(getState());
                if (!category) {
                    return pageList;
                }

                return [
                    ...pageList,
                    {
                        isLastActive: Boolean(options?.isLastActive),
                        path: `${CATALOG_ROUTE}/${CategoryService.makeCategoryUrl(category.code, category.id)}`,
                        title: category.title,
                    },
                ];
            },
            [PAGES.HOME_PAGE, PAGES.CATALOG_PAGE]
        );

        dispatch(actionSetBreadCrumbsList(categoryPageList));
    };
